import { Trans } from '@lingui/react'
import { func, number } from 'prop-types'
import { type FunctionComponent } from 'react'

import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import InputCheckbox from 'views/components/molecules/InputCheckbox'
import StarRating from 'views/components/molecules/StarRating'

import { MAX_RATING } from './consts'

const ListItem: FunctionComponent<ComponentProps> = ({
  stars,
  onClick,
  selected,
}) => {
  return (
    <li className="e-StarRatingStacked__listItem">
      <InputCheckbox
        name={`e-rating-star-${stars}`}
        id={`e-rating-star-${stars}`}
        type="radio"
        value={selected === stars ? 'on' : 'off'}
        onClick={() => onClick(stars)}
      >
        <StarRating rating={stars} iconSize="small" centered inline />
        <span className="u-padding-xx-small--left a-h4-tiny">
          {stars !== MAX_RATING && <Trans id="searchResults.label.andMore" />}
        </span>
      </InputCheckbox>
    </li>
  )
}

const propTypes = {
  stars: number.isRequired,
  onClick: func.isRequired,
  selected: number,
}

const defaultProps = {
  selected: null,
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default ListItem
